<template>
  <ul id="accessory-info-parts-list">
    <li v-for="(id, key) in selectedElements" :key="key">
      <IconBtoParts :parts-id="partsInfo[id].beadId" />
      <span class="parts-name">
        {{ partsInfo[id].bead_name }}
      </span>
      <p class="parts-description">
        {{ filterDescription(partsInfo[id].description) }}
      </p>
    </li>
  </ul>
</template>

<script>
import IconBtoParts from "@/components/BtoPanel/IconBtoParts.vue";

export default {
  name: "AccessoryInfoPartsList",

  components: {
    IconBtoParts,
  },

  props: {
    partsInfo: {
      type: Object,
    },
  },

  computed: {
    /**
     * 選択中の部材IDをリストを返す
     */
    selectedElements: {
      get() {
        let size = "size_" + this.$store.state.current_size_id;
        let obj = Object.assign({}, this.$store.state.id_holder[size]);
        let arr = Array.from(Object.values(obj));
        return new Set(
          arr.map((id) => {
            return id.padStart(3, "0");
          })
        );
      },
    },
  },

  methods: {
    /**
     * nbspを全角スペースに変換する
     */
    filterDescription(text) {
      return text == "&nbsp;" ? "　" : text;
    },
  },
};
</script>

<style scoped lang="stylus">

#accessory-info-parts-list
  max-height: 75vh

@css {
  #accessory-info-parts-list {
    @apply overflow-y-scroll h-auto border border-gray-100 bg-white mx-2 p-1
  }
  #accessory-info-parts-list li {
    display: grid;
    grid-template-areas: 'a b' 'c c';
    grid-template-columns: 24px 1fr;
    gap: 0.5em 0;
  }
  #accessory-info-parts-list .parts-name {
    grid-area: b;
    align-self: center;
    @apply ml-2
  }
  #accessory-info-parts-list .parts-description {
    grid-area: c;
    @apply mb-4 px-2 w-full text-justify
  }
}
</style>
